import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    name: localStorage.getItem("name") || "",
    accessToken: localStorage.getItem("accessToken") || "",
    refreshToken: localStorage.getItem("refreshToken") || "",
    userType: localStorage.getItem("userType") || 0,
    privileges: localStorage.getItem("privileges") || [],
    recordsPerPage: localStorage.getItem("recordsPerPage") || 10,
    mapHeight: localStorage.getItem("mapHeight") || 400,
    showDense: localStorage.getItem("showDense") || "show",
    employerLogo: localStorage.getItem("employerLogo") || "",
    employerName: localStorage.getItem("employerName") || "",
    contractorName: localStorage.getItem("contractorName") || "",
    language: localStorage.getItem("language") || "en"
  },
  getters: {
    ACCESSTOKEN: state => {
      return state.accessToken;
    },
    REFRESHTOKEN: state => {
      return state.refreshToken;
    },
    NAME: state => {
      return state.name;
    },
    USERTYPE: state => {
      return state.userType;
    },
    PRIVILEGES: state => {
      return state.privileges;
    },
    PERPAGE: state => {
      return state.recordsPerPage;
    },
    MAPHEIGHT: state => {
      return state.mapHeight;
    },
    SHOWDENSE: state => {
      return state.showDense;
    },
    EMPLOYERLOGO: state => {
      return state.employerLogo;
    },
    EMPLOYERNAME: state => {
      return state.employerName;
    },
    CONTRACTORNAME: state => {
      return state.contractorName;
    },
    LANGUAGE: state => {
      return state.language;
    }
  },
  mutations: {
    AUTH_SUCCESS: (state, payload) => {
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
      state.name = payload.name;
      state.userType = payload.userType;
      state.privileges = payload.privileges;
      state.employerLogo = payload.employerLogo;
      state.employerName = payload.employerName;
      state.contractorName = payload.contractorName;
      state.language = payload.language;
    },
    LOGOUT: state => {
      state.accessToken = "";
      state.accessToken = "";
      state.name = "";
      state.userType = 0;
      state.privileges = [];
      state.employerLogo = "";
      state.employerName = "";
      state.contractorName = "";
    },
    UPDATE_PERPAGE: (state, payload) => {
      state.recordsPerPage = payload;
    },
    UPDATE_MAPHEIGHT: (state, payload) => {
      state.mapHeight = payload;
    },
    UPDATE_SHOWDENSE: (state, payload) => {
      state.showDense = payload;
    }
  },
  actions: {
    login({ commit }, formData) {
      return new Promise((resolve, reject) => {
        var access_token = "";
        var refresh_token = "";
        var name = "";
        var userType = 0;
        var privileges = [];
        var employerLogo = "";
        var employerName = "";
        var contractorName = "";
        var language = "";
        axios({ url: "/auth/login/", data: formData, method: "POST" })
          .then(resp => {
            access_token = resp.data.access;
            refresh_token = resp.data.refresh;
            name = resp.data.name;
            userType = parseInt(resp.data.type);
            privileges = resp.data.privileges.split(",");
            employerLogo = resp.data.employer_logo;
            employerName = resp.data.employer_name;
            contractorName = resp.data.contractor_name;
            language = resp.data.language;

            axios.defaults.headers.common["Authorization"] =
              "Bearer " + access_token;
            localStorage.setItem("accessToken", access_token);
            localStorage.setItem("refreshToken", refresh_token);
            localStorage.setItem("name", name);
            localStorage.setItem("userType", userType);
            localStorage.setItem("privileges", privileges);
            localStorage.setItem("employerLogo", employerLogo);
            localStorage.setItem("employerName", employerName);
            localStorage.setItem("contractorName", contractorName);
            localStorage.setItem("language", language);
            const payload = {
              accessToken: access_token,
              refreshToken: refresh_token,
              name: name,
              userType: userType,
              privileges: privileges,
              employerLogo: employerLogo,
              employerName: employerName,
              contractorName: contractorName,
              language: language
            };
            commit("AUTH_SUCCESS", payload);
            resolve(resp);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/auth/logout/",
          method: "GET",
          headers: { Authorization: `Bearer ${state.accessToken}` }
        })
          .then(() => {
            delete axios.defaults.headers.common["Authorization"];
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("name");
            localStorage.removeItem("userType");
            localStorage.removeItem("privileges");
            localStorage.removeItem("employerLogo");
            localStorage.removeItem("employerName");
            localStorage.removeItem("contractorName");
            commit("LOGOUT");
            resolve();
          })
          .catch(err => {
            delete axios.defaults.headers.common["Authorization"];
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("name");
            localStorage.removeItem("userType");
            localStorage.removeItem("privileges");
            localStorage.removeItem("employerLogo");
            localStorage.removeItem("employerName");
            localStorage.removeItem("contractorName");
            commit("LOGOUT");
            reject(err);
          });
      });
    },
    isUserLoggedIn({ commit, state }) {
      return new Promise(resolve => {
        if (!state.accessToken) {
          delete axios.defaults.headers.common["Authorization"];
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("name");
          localStorage.removeItem("userType");
          localStorage.removeItem("privileges");
          localStorage.removeItem("employerLogo");
          localStorage.removeItem("employerName");
          localStorage.removeItem("contractorName");
          commit("LOGOUT");
          resolve(false);
        } else {
          resolve(true);
        }
      });
    },
    saveRecordsPerPage({ commit }, value) {
      localStorage.setItem("recordsPerPage", value);
      commit("UPDATE_PERPAGE", value);
    },
    saveMapHeight({ commit }, value) {
      localStorage.setItem("mapHeight", value);
      commit("UPDATE_MAPHEIGHT", value);
    },
    saveShowDense({ commit }, value) {
      localStorage.setItem("showDense", value);
      commit("UPDATE_SHOWDENSE", value);
    }
  }
});
